import { apiClient } from '@/core/api';
import type {
  ChatInput,
  ChatResponse,
  KnowledgeChunk,
  SearchInput,
} from './types';

const BASE = '/assistant/';

/** RAG semantic search over the org's knowledge base. */
export async function search(input: SearchInput): Promise<KnowledgeChunk[]> {
  const { data } = await apiClient.post<KnowledgeChunk[]>(`${BASE}search/`, input);
  return data;
}

/** Grounded chat: returns `{ answer, sources }`. */
export async function chat(input: ChatInput): Promise<ChatResponse> {
  const { data } = await apiClient.post<ChatResponse>(`${BASE}chat/`, input);
  return data;
}
